import { showToast } from '@lokalise/louis';
import { createApi } from '@reduxjs/toolkit/query/react';

import bugsnag from '@app/utils/bugsnag';

import fetchBaseQuery from '../fetchBaseQuery';
import type { ToggleLanguagePayload } from './types';

const validateStatus = (response: Response) => {
    if (response.status === 200) {
        return true;
    }

    showToast({ type: 'error', title: 'Something went wrong, please contact support via chat or hello@lokalise.com' });
    bugsnag.log(`Failed to toggle language, status: ${response.status}`);

    return false;
};

export const ProjectLanguagesApi = createApi({
    reducerPath: 'projectLanguages',
    baseQuery: fetchBaseQuery(),
    endpoints: (builder) => ({
        updateLanguages: builder.mutation<string, ToggleLanguagePayload>({
            query: ({ projectId, languagesIds, branch }) => ({
                method: 'POST',
                url: `/project/${projectId}/toggle-language`,
                body: { languagesIds, branch },
                validateStatus,
            }),
        }),
    }),
});

export type { ProjectLanguage } from './types';

export const { useUpdateLanguagesMutation } = ProjectLanguagesApi;

export default ProjectLanguagesApi;
